import { create } from 'zustand';

// Load initial locations from localStorage if available
const getInitialLocations = () => {
  const storedLocations = localStorage.getItem('locationsData');
  return storedLocations ? JSON.parse(storedLocations) : null;
};

const useLocationsStore = create((set) => ({
  locations: getInitialLocations(),

  // Function to set new locations
  setLocations: (newLocations) => {
    set(() => ({ 
      locations: newLocations, 
    }));
    localStorage.setItem('locationsData', JSON.stringify(newLocations));
  },

  // Function to clear locations
  clearLocations: () => {
    set(() => ({ 
      locations: null,  
    }));
    localStorage.removeItem('locationsData');
  },
}));

export default useLocationsStore;